import type { PlanRow } from '../models/useBilling'

/**
 * The order the plan cards read in on the picker: cheapest to most expensive, with the
 * quote-only plan (Enterprise) last — Free, Pro, Business, Enterprise.
 *
 * ⚠⚠ A PRICE SORT ALONE PUTS ENTERPRISE SECOND. Enterprise carries `monthly_fee_cents = 0`
 * because it has no list price at all, which sorts it beside Free — the two zeros, and the card
 * that says "Custom" landed between "Free" and "$20 / mo". The ladder is what the customer
 * reads, so the quote plan has to sit at the end of it, not inside it.
 *
 * ⚠ The rank reads `metered`, never a plan NAME — the same flag `Billing.tsx` derives its
 * `enterprise` card from, and the rule `isPaidPlan` follows. A renamed or newly-added quote plan
 * sorts to the end without a change here.
 */
const rank = (plan: PlanRow): number => (plan.metered ? 0 : 1)

/** `Array.prototype.sort` comparator. Ties keep catalog order — `sort` is stable. */
export const byPlanOrder = (a: PlanRow, b: PlanRow): number =>
  rank(a) - rank(b) || a.monthlyFeeCents - b.monthlyFeeCents
